export default "__VITE_ASSET__bbb405c5__"